export default {
  namespaced: true,

  state: {
    loading: false,
    requestCount: 0
  },

  mutations: {
    START_LOADING(state) {
      state.requestCount++
      state.loading = true
    },

    STOP_LOADING(state) {
      state.requestCount--

      if (state.requestCount <= 0) {
        state.loading = false
        state.requestCount = 0
      }
    },

    FORCE_STOP(state) {
      state.loading = false
      state.requestCount = 0
    }
  },

  actions: {
    stopLoadingWithDelay({ commit }) {
      setTimeout(() => {
        commit('STOP_LOADING')
      }, 300)
    }
  }
}